module.exports = __webpack_public_path__ + "static/media/strategy.8e0fe1f8.svg";